export function formatCPF(value) {
  return value
    .replace(/\D/g, '')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
}

export function unformatCPF(value) {
  return value.replace(/\D/g, '');
}

export function validateCPF(value) {
  const cpf = value.replace(/\D/g, '');
  if (cpf.length !== 11) return false;
  if (/^(\d)\1{10}$/.test(cpf)) return false;
  let sum = 0;
  for (let i = 0; i < 9; i++) sum += parseInt(cpf[i]) * (10 - i);
  let r = (sum * 10) % 11;
  if (r === 10 || r === 11) r = 0;
  if (r !== parseInt(cpf[9])) return false;
  sum = 0;
  for (let i = 0; i < 10; i++) sum += parseInt(cpf[i]) * (11 - i);
  r = (sum * 10) % 11;
  if (r === 10 || r === 11) r = 0;
  if (r !== parseInt(cpf[10])) return false;
  return true;
}

export function formatCNPJ(value) {
  return value
    .replace(/\D/g, '')
    .replace(/(\d{2})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1/$2')
    .replace(/(\d{4})(\d{1,2})$/, '$1-$2');
}

export function formatCEP(value) {
  return value
    .replace(/\D/g, '')
    .replace(/(\d{5})(\d{1,3})$/, '$1-$2');
}

export function formatDateBR(value) {
  if (!value) return '—';
  const [y, m, d] = value.split('-');
  if (!y || !m || !d) return value;
  return `${d}/${m}/${y}`;
}

export function formatPhone(value) {
  const digits = value.replace(/\D/g, '');
  if (digits.length === 0) return '';
  if (digits.length <= 2) return `(${digits}`;
  if (digits.length <= 6) return `(${digits.slice(0, 2)}) ${digits.slice(2)}`;
  if (digits.length === 11) return `(${digits.slice(0, 2)}) ${digits.slice(2, 3)} ${digits.slice(3, 7)}-${digits.slice(7)}`;
  return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6, 10)}`;
}

export function validatePhone(value) {
  const cleaned = value.replace(/\D/g, '');
  if (cleaned.length === 11 && cleaned.charAt(2) === '9') return true;
  if (cleaned.length === 10 && cleaned.charAt(2) !== '9') return true;
  if (cleaned.length === 13 && cleaned.startsWith('55')) return true;
  return false;
}

export function formatBrazilianPhone(value) {
  let cleaned = value.replace(/\D/g, '');
  if (cleaned.startsWith('55') && cleaned.length >= 12) return `+${cleaned}`;
  if (cleaned.startsWith('0')) cleaned = cleaned.substring(1);
  if (cleaned.length === 10 || cleaned.length === 11) return `+55${cleaned}`;
  return `+${cleaned}`;
}

export function formatPhoneFromE164(value) {
  if (!value) return 'N/A';
  const cleaned = value.replace(/\D/g, '');
  if (cleaned.length === 13 && cleaned.startsWith('55')) {
    const number = cleaned.substring(2);
    return `(${number.substring(0, 2)}) ${number.substring(2, 7)}-${number.substring(7)}`;
  }
  return value;
}

export function formatRG(value) {
  return value
    .replace(/\D/g, '')
    .replace(/(\d{2})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
}

export function onlyNumbers(value) {
  return String(value || '').replace(/\D/g, '');
}

export function formatMoney(value) {
  const digits = String(value || '').replace(/\D/g, '');
  if (!digits) return '';
  const num = (parseInt(digits, 10) / 100).toFixed(2);
  const [intPart, decPart] = num.split('.');
  const formattedInt = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return `${formattedInt},${decPart}`;
}

export function validateMoney(value) {
  if (!value && value !== 0) return false;
  const num = typeof value === 'string' ? parseFloat(value.replace(/\./g, '').replace(',', '.')) : value;
  return !isNaN(num) && num >= 0;
}

export function validateCEP(value) {
  const digits = onlyNumbers(value);
  return digits.length === 8;
}

export function validateDateBR(value, options = {}) {
  if (!value) return false;
  const d = new Date(value + 'T00:00:00');
  if (isNaN(d.getTime())) return false;
  const [y, m, day] = value.split('-').map(Number);
  if (d.getMonth() + 1 !== m || d.getDate() !== day) return false;

  const { pastYears, futureYears } = options;
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

  if (pastYears !== undefined) {
    const minDate = new Date(today);
    minDate.setFullYear(minDate.getFullYear() - pastYears);
    if (d < minDate) return false;
  }
  if (futureYears !== undefined) {
    const maxDate = new Date(today);
    maxDate.setFullYear(maxDate.getFullYear() + futureYears);
    if (d > maxDate) return false;
  }
  return true;
}
